const CheckIcon = () => {
  return (
    <svg width="18" height="15" viewBox="0 0 18 15" fill="none">
      <path d="M1 7.6L7.21739 13L17 1" stroke="currentColor" strokeWidth="2" />
    </svg>
  );
};

export default CheckIcon;
